module.exports = __webpack_public_path__ + "static/the-software-essentialist-1f98eab0d032f8dd67a88506f4498e51.jpg";